import React from "react";
import ImgAngular from "./img/iep-angular-code.png";
import IEPmask from "./img/IEPmask";

function IEPCardPrototyping() {
	return (
		<section className="card-iep-prototyping">
			<h2 className="title">Building the front-end</h2>
			<div className="content-row">
				<article className="content">
					<p>
						After several UX &amp; UI presentations to the application users, I
						advised the team to switch from 'static' UI layout apps to
						interactive browser prototyping, using native HTML, CSS, and
						JavaScript.
					</p>
					<p>
						Anthem has a bespoke framework for building application interfaces,
						called{" "}
						<a
							className="link-inline"
							href="https://openanthem.github.io/nimbus-docs/latest/index.html"
							target="_blank"
							rel="noopener noreferrer"
						>
							Nimbus
						</a>{" "}
						. It was suggested I use this framework to continue prototyping.
					</p>
					<p>
						Having reviewed the documentation and other apps build with the
						framework, I advised the systems architect and applications director
						that it had major limitations.
					</p>
					<p>
						After much deliberation, the Angular framework was chosen as
						solution to pursue the interface build.
					</p>
				</article>
				<blockquote className="pullquote">
					…I am proficient in HTML, SCSS, and ES6 to where I can build UI
					prototypes that are 'production ready' for software development.
				</blockquote>
			</div>
			<figure className="image">
				<IEPmask />
				<img src={ImgAngular} alt="Angular code" />
			</figure>
		</section>
	);
}

export default IEPCardPrototyping;
